import React from 'react';
import { Link } from 'react-router-dom';

// Orb mark from the DepthMe app's 2026-09 brand refresh plus the wordmark.
const BrandLogo = ({ size = 32, to = '/', showWordmark = true, className = '' }) => (
  <Link to={to} className={`inline-flex items-center gap-2.5 ${className}`} aria-label="DepthMe home">
    <img
      src="/brand/depthme-icon-192.png"
      alt=""
      width={size}
      height={size}
      className="rounded-full shadow-[0_0_24px_rgba(139,107,255,0.35)]"
    />
    {showWordmark && (
      <span className="font-display text-lg font-light tracking-[0.18em] text-dm-ivory">
        DEPTH<span className="font-medium text-gold-gradient">ME</span>
      </span>
    )}
  </Link>
);

export default BrandLogo;
